import router from './router'

import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { login, getInfo, getAccessToken } from '@/api/login'
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false })

const whiteList = ['/index', '/auth-redirect', '/bind', '/register', '/IdentityType']
console.log(process.env)
router.beforeEach((to, from, next) => {
  NProgress.start()
  // setToken('access_token', 'NTNjZGE0MmZkYjBmNGVmMmExOGE5NjYyYTI4Y2I2ZTk=')
  // setToken('refresh_token', 'YzA4MjY3MDE3MTczNDZiNzg4YmZjOGJmYWYwOGNlNzg=')
  // setToken('access-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJkZWVwaW4tdXNlciIsInN1YiI6ImRlZXBpbl9kODB2YWE2c3J4MzJiNnJ4anZmbXJqcWw3cXN2eSIsImlzcyI6InVvc19hcHBzdG9yZSIsImlhdCI6MTcwMTE3NDE0OCwiZXhwIjoxNzAxMTgxMzQ4LCJqdGkiOiI5YTMwZWI2N2ExM2Y0NjFmOTk3OTE4Nzc2OGZlMDg0YyJ9.KDbHtcIAh0Ssk5DD__62DyhEOIWbCg5aQL25JuPBBUs')
  // if (getToken("access_token") && typeof(getToken("access_token")) != 'undefined' && getToken("refresh_token") && typeof(getToken("refresh_token")) != 'undefined') {
  if (getToken('access-token') && typeof (getToken('access-token')) != 'undefined') {
    /* has token */

    store.dispatch('getLanList')
    if (to.path === '/') {
      next({ path: '/index' })
      NProgress.done() // 页面加载进度条
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then((res) => {
          // 拉取user_info
          const roles = res.datas.dev_type
          // const  roles  =  2
          if (roles == 3) {
            removeToken('access-token')
            // removeToken("access_token");
            // removeToken("refresh_token");
            window.open(process.env.VUE_APP_AUTH_GATEWAY, '_self')
          } else if (roles == 2) {
            next({ path: '/IdentityType' })
          } else {
            store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => { // 根据roles权限生成可访问的路由表
              router.addRoutes(accessRoutes)  // 动态添加可访问路由表
              next({ ...to, replace: true })  // hack方法 确保addRoutes已完成
            })
          }
        }).catch((err) => {
          // next({ path: '/index' })
        })

      } else {

        let roles = store.getters.roles
        store.dispatch('GetInfo')
        store.dispatch('GenerateRoutes', { roles })
        next()
      }
      // next()
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      if (window.location.search) {
        // 获取指定参数值
        let code = window.location.search.split('&')[0].split('=')[1] // 1
        let state = window.location.search.split('&')[1].split('=')[1] // 1
        if (code) {
          getAccessToken({ code, state }).then((res) => {
            let link = window.location.href.split('?')[0]
            if (res.status === 200) {
              window.location.href = link
              // //     // window.open(res.datas, "_self")
              // // } else {
              // //     resolve()
              // //     Message.error(res.desc)
            }

            // window.open(link, "_self")
            // next({ path: '/index' })
          }).catch((error) => {
            reject(error)
          })
          // setToken("access_token", access_token);
          // setToken("refresh_token", refresh_token);
          // next({ path: '/index' })
        } else {
          login().then((res) => {
            if (res.status === 200) {
              window.location.href = res.datas
              // window.open(res.datas, "_self")
            } else {
              // resolve()
              Message.error(res.desc)
            }
          }).catch((error) => {
            reject(error)
          })
        }
      } else {
        login().then((res) => {
          if (res.status === 200) {
            window.location.href = res.datas
            // window.open(res.datas, "_self")
          } else {
            // resolve()
            Message.error(res.desc)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    } else {
      next('/index') // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
